import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {PhysicianService} from '../service/physician.service';

@Component({
  selector: 'app-physicisan-review-comments',
  templateUrl: './physicisan-review-comments.component.html',
  styleUrls: ['./physicisan-review-comments.component.css']
})
export class PhysicisanReviewCommentsComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private physicianService: PhysicianService) {}
    disableFalg:boolean = false;
  ngOnInit() {
  }

    publishReviewComments(id){
      this.physicianService.publishPhysicianComment(id).subscribe(
          data => {

          }
      )
    }

    checkPublish(data) {
      if(data.published){
        this.disableFalg = true;
      } else {
        this.disableFalg = false;
      }

    }

}
